module.exports = __webpack_public_path__ + "img/flairboat.2c74a8bf.png";